
import Navbar from "./components/navbar/navbar";
import Weather from "./components/weatherpage/weather";

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Weather/>
    </div>
  );
}

export default App;
